import { LanguagesEnum } from '../../../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  footer_part1: {
    [LanguagesEnum.English]: 'Total VAT Amount for ',
    [LanguagesEnum.Greek]: 'Total VAT Amount for ',
  },
  footer_part2: {
    [LanguagesEnum.English]:
      ' supplied from the Member State of Identification (€): ',
    [LanguagesEnum.Greek]:
      ' supplied from the Member State of Identification (€): ',
  },
};

export default CONFIGURATION;
